import React from 'react';
import Joyride, { ACTIONS, EVENTS, STATUS } from 'react-joyride';
import { useTheme } from '@mui/material';
import useOnboardingTour from '../../hooks/useOnboardingTour';

const OnboardingTour: React.FC = () => {
  const theme = useTheme();
  const { steps, run, stepIndex, handleJoyrideCallback } = useOnboardingTour();

  return (
    <Joyride
      steps={steps}
      run={run}
      stepIndex={stepIndex}
      continuous
      showSkipButton
      callback={handleJoyrideCallback}
      locale={{ back: 'Back', last: 'Close', close: 'Close', skip: 'Skip the Tour' }}
      styles={{
        options: {
          arrowColor: theme.palette.background.paper,
          backgroundColor: theme.palette.background.paper,
          overlayColor: 'rgba(0, 0, 0, 0.5)',
          primaryColor: theme.palette.primary.main,
          textColor: theme.palette.text.primary,
          zIndex: 10000,
        },
        tooltip: {
          borderRadius: 8,
          fontSize: '14px',
        },
        buttonNext: {
          backgroundColor: theme.palette.primary.main,
          borderRadius: 4,
          color: '#fff',
          padding: '8px 16px',
        },
        buttonBack: {
          marginRight: 10,
          color: theme.palette.text.primary,
        },
        buttonSkip: {
          color: theme.palette.text.secondary,
        },
      }}
      floaterProps={{
        disableAnimation: true,
      }}
    />
  );
};

export default OnboardingTour;
